export default "__VITE_ASSET__3caa958d__"